import styled from "@emotion/styled";

const TypographyWrapper = styled.div`
  font-family: "${({ theme }) =>
    theme.typography.body1.fontFamily.split(",")[0]}", ${({ theme }) =>
      theme.typography.body1.fontFamily.split(",")[1]};
  & p {
    font-family: "${({ theme }) =>
    theme.typography.body1.fontFamily.split(",")[0]}", ${({ theme }) =>
      theme.typography.body1.fontFamily.split(",")[1]};
  }
  & h1,
  h2,
  h4,
  h5,
  h6 {
    font-family: "${({ theme }) =>
    theme.typography.h1.fontFamily.split(",")[0]}", ${({ theme }) =>
      theme.typography.h1.fontFamily.split(",")[1]};
  }
`;

export default TypographyWrapper;
